// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"46033c9a","278":"5c10da90","357":"e312e432","532":"53e52204","604":"f09d682b","628":"8e8c262e","890":"1fafaaf4"}[chunkId] + ".chunk.js";
};